export default __webpack_public_path__ + "static/media/white-bg-chrome.9a017668.svg";